export const COUNT_STATIC_TABS = 1;
